import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import reduxThunk from 'redux-thunk';
//
import rootReducer from './redux/store/index';

const dataStore = createStore(rootReducer, applyMiddleware(reduxThunk));

ReactDOM.render(
    <Provider store={dataStore}>
        <App />
    </Provider>, document.getElementById('root')
);
